import React, { useState, useEffect } from 'react';
import axios from 'axios';

const FormAnalytics = () => {
  const [downloadCount, setDownloadCount] = useState(0);
  const [printCount, setPrintCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    
    const updateLocalCounts = () => {
      setDownloadCount(parseInt(localStorage.getItem('jobForm_download_count') || '0', 10));
      setPrintCount(parseInt(localStorage.getItem('jobForm_print_count') || '0', 10));
    };


    const fetchAnalytics = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}analytics/form-analytics`);
        setDownloadCount(response.data.downloadCount);
        setPrintCount(response.data.printCount);
      } catch (error) {
        console.error('Error fetching analytics:', error);
        setError('Failed to fetch analytics. Using local counts.');
        updateLocalCounts(); 
      } finally {
        setIsLoading(false);
      }
    };

    // Initial fetch
    fetchAnalytics();

    // Listen for storage changes (for demo purposes)
    window.addEventListener('storage', updateLocalCounts);

    // Optional: Poll backend every 30 seconds for updates
    const intervalId = setInterval(fetchAnalytics, 30000);

    return () => {
      window.removeEventListener('storage', updateLocalCounts);
      clearInterval(intervalId);
    };
  }, []);

  return (
 
       <div className=" rounded-lg shadow-md p-6 text-center">
    <h3 className="text-xl font-semibold text-gray-800 mb-4">Form Analytics</h3>
    <p className="text-gray-600">Track downloads, prints, and shares of the job application form.</p>
    <div className="mt-4">
      {isLoading ? (
        <p className="text-sm text-gray-600">Loading analytics...</p>
      ) : error ? (
        <p className="text-sm text-red-600">{error}</p>
      ) : (
    <>
          <p className="text-sm text-gray-600">Total Downloads</p>
        <p className="text-2xl font-bold text-gray-900">{downloadCount}</p>
    
      <p className="text-sm text-gray-600">Total Prints</p>
        <p className="text-2xl font-bold text-gray-900">{printCount}</p>

    </>
  )}
    </div>
  </div>
 
  );
};

export default FormAnalytics;